import { Directive, HostListener, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { TableComponent } from '../..';
import { SystemTableService } from '../../services';

@Directive({
  selector: '[appSystemSortableColumn]',
  host: {
    class: 'cursor-pointer hover:bg-gray-100',
    '[class.text-system-500]': 'sorted',
    '[attr.aria-sort]': 'sortOrder',
  },
})
export class SortableColumnDirective implements OnInit, OnDestroy {
  @Input() field: string | undefined;

  sorted: boolean | undefined;
  sortOrder: string | undefined;

  private destroy$ = new Subject<void>();
  constructor(
    private dt: TableComponent,
    private tableService: SystemTableService
  ) {}
  @HostListener('click', ['$event'])
  onClick() {
    this.dt.sort({ field: this.field });
  }

  ngOnInit(): void {
    this.updateSortState();
    this.tableService.sortSource$
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.updateSortState())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateSortState() {
    this.sorted = this.dt.isSorted(<string>this.field) as boolean;
    this.sortOrder = this.sorted ? (this.dt.sortOrder === 1 ? 'ascending' : 'descending') : 'none';
  }
}

@NgModule({
  declarations: [SortableColumnDirective],
  exports: [SortableColumnDirective],
  imports: [],
})
export class SystemSortableColumnModule {}
